import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import ZcashWalletButton from '../wallet/ZcashWalletButton'

const navigation = [
	{ name: 'Privacy Punks', href: '/privacy-punks' },
	{ name: 'Collections', href: '/collections' },
	{ name: 'Create', href: '/create' },
	{ name: 'My NFPTs', href: '/my-nfpts' },
	{ name: 'Marketplace', href: '/marketplace' },
	{ name: 'How It Works', href: '/how-it-works' },
	{ name: 'Docs', href: '/docs' },
	{ name: 'Zones', href: '/zones' },
	{ name: 'Bridge', href: '/bridge' },
]

export function Header() {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
	const location = useLocation()

	// Highlight a nav item on its page and any sub-route (e.g. /docs/transfers).
	const isActive = (href: string) =>
		href === '/'
			? location.pathname === '/'
			: location.pathname === href || location.pathname.startsWith(`${href}/`)

	return (
		<header className="bg-white shadow-sm border-b">
			<nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" aria-label="Top">
				<div className="flex h-16 items-center justify-between">
					{/* Logo */}
					<div className="flex items-center">
						<Link to="/" className="flex items-center space-x-2">
							<div className="h-8 w-8 rounded-lg bg-zcash-500 flex items-center justify-center">
								<span className="text-white font-bold text-sm">S</span>
							</div>
							<span className="text-xl font-bold text-gray-900">Secresea</span>
						</Link>
					</div>

					{/* Desktop navigation */}
					<div className="hidden md:flex md:items-center md:space-x-6">
						{navigation.map((item) => (
							<Link
								key={item.name}
								to={item.href}
								className={`px-3 py-2 rounded-md text-sm font-medium transition-colors inline-flex items-center gap-2 ${
									isActive(item.href)
										? 'bg-zcash-100 text-zcash-700'
										: 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
								}`}
							>
								{item.name}
							</Link>
						))}
					</div>

					{/* Wallet & Profile */}
					<div className="flex items-center space-x-4">
						<ZcashWalletButton size="sm" className="hidden sm:flex" />
						<ZcashWalletButton size="sm" showBalance={false} className="sm:hidden" />
						
						{/* Mobile menu button */}
						<div className="md:hidden">
							<button
								type="button"
								className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500"
								onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
							>
								{mobileMenuOpen ? (
									<XMarkIcon className="h-6 w-6" aria-hidden="true" />
								) : (
									<Bars3Icon className="h-6 w-6" aria-hidden="true" />
								)}
							</button>
						</div>
					</div>
				</div>

				{/* Mobile menu */}
				{mobileMenuOpen && (
					<div className="md:hidden border-t border-gray-200 py-4">
						<div className="space-y-1">
							{navigation.map((item) => (
								<Link
									key={item.name}
									to={item.href}
									className={`flex items-center justify-between px-3 py-2 rounded-md text-base font-medium transition-colors ${
										isActive(item.href)
											? 'bg-zcash-100 text-zcash-700'
											: 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
									}`}
									onClick={() => setMobileMenuOpen(false)}
								>
									<span>{item.name}</span>
								</Link>
							))}
						</div>
					</div>
				)}
			</nav>
		</header>
	)
} 